import { computed, reactive } from '@nuxtjs/composition-api';
import type { UseMetaInterface } from './useMeta';

interface Notifications {
  isMeta: boolean,
  metaSKUS: string[],
  canAddMultipleSubProducts: boolean,
}

const state = reactive<Notifications>({
  isMeta: false,
  metaSKUS: [],
  canAddMultipleSubProducts: false,
});


/**
*
 * See the {@link UseMetaInterface} for a list of methods and values available in this composable.
 */
export function useMeta(): UseMetaInterface {
 

  return {
    isMeta: computed(() => state.isMeta),
    metaSKUS: computed(() => state.metaSKUS),
    setMeta: (val: boolean, skus: string[]) => { state.isMeta = val; state.metaSKUS = skus; },
    canAddMultipleSubProducts: computed(() => state.canAddMultipleSubProducts),
    setCanAddMultipleSubProducts: (val: boolean) => state.canAddMultipleSubProducts = val
  };
}

export default useMeta;
export * from './useMeta';
